export const getHomeSettings = (postData) => {
  let resp = {
    success: true,
    userID: 2,
    subtitle: "subtitle stuff",
    aboutUs: "<ol><li><p><strong><em>uhfiusdhuifsd</em></strong></p></li></ol>",
    accentColor: "C03B3B",
    backgroundColor: "0e1682",
    backgroundGradient: ["0e1682", "45046c", "550058"],
    socials: {
      facebook: "https://www.facebook.com/example",
      instagram: "https://www.instagram.com/example",
      twitter: "https://www.twitter.com/example",
      youtube: "https://www.youtube.com/example",
    },
  };

  // address, networkname, networklogo, website baked into network data

  return resp;
};
